import { Reveal } from "@/components/site/motion";
import { useLenis } from "lenis/react";
import { ArrowRight, Download, Building2 } from "lucide-react";

const PACK_URL = `${process.env.REACT_APP_BACKEND_URL}/api/partnership-pack`;

export const PartnerHero = () => {
  const lenis = useLenis();
  const goForm = () => {
    const el = document.getElementById("enquiry");
    if (el && lenis) lenis.scrollTo(el, { offset: -80 });
    else if (el) el.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <section data-testid="partner-hero" className="relative overflow-hidden pt-36 pb-20 sm:pt-44 sm:pb-24">
      <div className="absolute inset-0 radial-glow" />
      <div className="absolute inset-0 grid-bg mask-fade-b opacity-60" />
      <div className="grain" />
      <div className="relative mx-auto max-w-5xl px-5 sm:px-8 text-center">
        <Reveal>
          <div className="mx-auto inline-flex items-center gap-2 rounded-full bg-cobalt/10 px-3.5 py-1.5">
            <Building2 className="h-3.5 w-3.5 text-cobalt" />
            <span className="text-xs font-semibold uppercase tracking-[0.18em] text-cobalt">For Universities & HE Providers</span>
          </div>
        </Reveal>
        <Reveal delay={0.06}>
          <h1 className="mt-7 font-display font-extrabold tracking-tighter text-ink text-[3rem] leading-[0.95] sm:text-6xl lg:text-[4.4rem]">
            Partner with OpenDegree
          </h1>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="mx-auto mt-7 max-w-2xl text-lg leading-relaxed text-slatey">
            Helping UK higher education providers identify, engage and enrol suitable students through an
            AI-powered admissions platform.
          </p>
        </Reveal>
        <Reveal delay={0.18}>
          <div className="mt-9 flex flex-wrap items-center justify-center gap-3">
            <button
              data-testid="partner-become-btn"
              onClick={goForm}
              className="group inline-flex items-center gap-2 rounded-2xl bg-cobalt px-7 py-4 text-[15px] font-semibold text-white shadow-[0_14px_34px_rgba(16,76,250,0.30)] transition-transform duration-200 hover:scale-[1.03] active:scale-95"
            >
              Become a Partner
              <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
            </button>
            <a
              data-testid="partner-download-pack-btn"
              href={PACK_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center gap-2 rounded-2xl border-2 border-cobalt/25 bg-white px-7 py-4 text-[15px] font-semibold text-cobalt transition-colors duration-200 hover:bg-cobalt/5"
            >
              <Download className="h-4 w-4" />
              Download Partnership Pack
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
